import { UIGameAnimationBase } from './animation/UIGameAnimationBase.ts';
export class UIGameVerticalMovementAnimation extends UIGameAnimationBase {
    onGameTick(deltaTime, elapsedMS) {
        if (this.viewToAnimate == undefined) this.stop();
        this.viewToAnimate.y += this.viewToAnimate.height * 0.003 * this.animationDirection * this.animationSpeedMultiplier * deltaTime;
        const isTopEdge = this.viewToAnimate.y < this.initialY - this.maxAnimationDistance;
        const isBottomEdge = this.viewToAnimate.y > this.initialY;
        if (isTopEdge) {
            this.animationDirection = 1;
            this.viewToAnimate.y = this.initialY - this.maxAnimationDistance;
        }
        if (isBottomEdge) {
            this.animationDirection = -1;
            this.viewToAnimate.y = this.initialY;
        }
    }
    resetToDefaultState() {
        this.viewToAnimate.y = this.initialY;
    }
    constructor(viewToAnimate, maxAnimationDistance, animationSpeedMultiplier = 1){
        super(), this.animationDirection = -1, this.forceEnableAnimation = false;
        this.initialY = viewToAnimate.y;
        this.maxAnimationDistance = maxAnimationDistance;
        this.animationSpeedMultiplier = animationSpeedMultiplier;
        this.viewToAnimate = viewToAnimate;
        this.setOnStopCallback(()=>this.resetToDefaultState());
    }
}
